export enum SelectType {
  STANDARD = 'STANDARD',
  ASYNC = 'ASYNC',
  CREATABLE = 'CREATABLE',
  ASYNC_CREATABLE = 'ASYNC_CREATABLE',
}
